import { useMemo } from "react";

import { PieChart } from "@components/v2";
import { useDesignElementManagerV2 } from "@hooks/use-design-element-manager";

interface Props {
  data: { valueBlended: number; valueFt: number; valueRtn: number };
}

export const RevenuePieChart = ({ data }: Props) => {
  const { designElementManager } = useDesignElementManagerV2();
  const valueFt = data.valueFt;
  const valueRtn = data.valueRtn;

  const result = useMemo(() => {
    return [
      {
        value: valueFt,
        label: "New",
        color: designElementManager.getColorForIndex(0),
      },
      {
        value: valueRtn,
        label: "Returning",
        color: designElementManager.getColorForIndex(1),
      },
    ];
  }, [designElementManager, valueFt, valueRtn]);

  return <PieChart data={result} showTooltip />;
};
